import {connect} from "react-redux"
import {createSelector} from "reselect"
import {BundleType} from "../../config/constants"
import {AggregatorColourwayBundlesApiContract} from "../../models/searchApi/bundle"
import {getColourChipUrl, getProductImageUrl} from "../../utils/getImageUrls"
import {ColourwayData} from "../../models/searchApi"
import type State from "../../models/state"
import {formatTitle, formatPdpLink} from "../../utils/colourwayBuilders"
import {selectPriceType} from "../../utils/priceFormatter/selectPriceType"
import {SofaColourwayData} from "../../models/searchApi/sofa"
import {fetchAdditionalColourchipsThunk, setAdditionalColourchipsLoading} from "../../ducks/productSummary"

const selectColourways = (state: State) => state.productSummary.summaryData.colourways
const selectType = (state: State) => state.productSummary.summaryData.type
const selectImageCdnUrl = (state: State) => state.productSummary.summaryData.imageCdnUrl
const selectBaseUrl = (state: State) => state.productSummary.summaryData.baseUrl
const selectTitle = (state: State) => state.productSummary.summaryData.title
const selectCurrencyCode = (state: State) => state.productSummary.summaryData.currencyCode
const selectDepartment = (state: State) => state.productSummary.summaryData.department
const selectFit = (state: State) => state.productSummary.summaryData.fit
const selectIsEnglishLang = (state: State) => state.request.isEnglishLang
const selectText = (state: State) => state.text

const colourchipsSelector = createSelector(
    [
        selectColourways,
        selectType,
        selectImageCdnUrl,
        selectBaseUrl,
        selectTitle,
        selectCurrencyCode,
        selectDepartment,
        selectFit,
        selectIsEnglishLang,
        selectText,
    ],
    (colourways, type, imageCdnUrl, baseUrl, title, currencyCode, department, fit, isEnglishLang, text) =>
        (colourways as ColourwayData[]).map(colourway => ({
            itemNumber: colourway.id,
            colourChipUrl: getColourChipUrl({
                type,
                id:
                    type === BundleType
                        ? (colourway as unknown as AggregatorColourwayBundlesApiContract).associatedColourway
                              ?.itemNumber
                        : colourway.id,
                imageCdnUrl,
                colourChipImage: (colourway as SofaColourwayData)?.cci,
            }),
            linkUrl: formatPdpLink(baseUrl, colourway.url),
            isSelected: colourway.s,
            colour: colourway.c,
            title: colourway.t ?? `${colourway.c} ${title}`,
            price: selectPriceType(colourway.p, colourway?.sp),
            currencyCode,
            department,
            altText: formatTitle({
                title,
                department,
                fit,
                selectedColourway: colourway,
                isEnglishLang,
            }),
            text,
        })),
)
const colourWayImageUrlBuilder = (id: string) => (_dispatch, getState: () => State) => {
    const state = getState()
    const {imageCdnUrl, productImageUrlPart, lgImagePath, type, usePDPImage} = state.productSummary.summaryData
    const {
        akamaiImageParams: {sm},
    } = state.productSummary
    const imageUrl = getProductImageUrl({
        imageCdnUrl,
        productImageUrlPart,
        lgImagePath,
        id,
        type,
        akamaiImageQueryParams: sm,
        im: "",
        usePDPImage,
    })
    return imageUrl
}

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {title},
            numberOfAllColourways,
            additionalColourchipsLoading,
            colourChipConfig,
        },
        lazyload: {colourchips: lazyloadColourchips},
        text,
        request: {headers},
        template,
    } = state

    return {
        colourchips: colourchipsSelector(state),
        text,
        title,
        lazyloadColourchips,
        numberOfAllColourways,
        additionalColourchipsLoading,
        realm: (headers["x-next-realm"] as string) || "next",
        templating: template,
        colourChipConfig,
    }
}

export const mapDispatchToProps = {
    fetchAdditionalColourchipsThunk,
    setAdditionalColourchipsLoading,
    colourWayImageUrlBuilder,
}

export default connect(mapStateToProps, mapDispatchToProps)
